"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingRemediationDataError = void 0;
const custom_error_1 = require("./custom-error");
class MissingRemediationDataError extends custom_error_1.CustomError {
    constructor() {
        super('Remediation data is required to apply fixes', custom_error_1.ERROR_CODES.MissingRemediationData);
    }
}
exports.MissingRemediationDataError = MissingRemediationDataError;
//# sourceMappingURL=missing-remediation-data.js.map